import React from "react";
import { Link } from "react-router-dom";

import { localizer } from '../../Translator'

import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import Paper from '@material-ui/core/Paper';
import { Grid } from "@material-ui/core";
import Container from '@material-ui/core/Container'
import { Backdrop, CircularProgress } from "@material-ui/core"
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography'
import { Button } from  "@material-ui/core"
import IconButton from '@material-ui/core/IconButton'
import Checkbox from '@material-ui/core/Checkbox'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemText from '@material-ui/core/ListItemText'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Pagination from '@material-ui/lab/Pagination'
import PaginationItem from '@material-ui/lab/PaginationItem'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'

import { ShipmentRow } from "./sections/ShipmentRow";

import { GridHeaderFilter } from '../common/HeaderComponentStyled.js'
import { TableRowHeaderStyled, TableRowStyled , TableCellStyled} from '../common/TableStyled.js'
import { TableStyled } from '../common/TableStyled.js'
import { TextFieldStyled, AutocompleteStyled } from "../common/InputStyled";
import ScreenHeading from "../common/ScreenHeading.js";

import DateCustom from "../Utilities/DateCustom";
import CurrencyCustom from '../Utilities/CurrencyCustom.js';
import { SnackbarCustom } from "../Utilities/SnackbarCustom"
import Roles from "../Utilities/Roles.js"
import StateCodes from "../Utilities/StateCodes.js"

import InboxCli from "../../sdk/InboxCli";
import AuthCli from "../../sdk/AuthCli.js";
import OutboxCli from "../../sdk/OutboxCli";
import ProductCli from "../../sdk/ProductCli"
import CycleCli from "../../sdk/CycleCli.js"
import ReportCli from "../../sdk/ReportCli.js";

const SHIPMENT_PAGE_SIZE = 50
const SHIPMENT_PAGE_SIZE_OPTIONS = [50, 100, 200]
const MAX_SHIPMENTS_TO_DOWNLOAD = 500
//const MAX_SHIPMENTS_COUNT = 99999;
const USERS_PAGE_SIZE = 100
const BATCH_PAGE_SIZE = 25
const AUTOPREFETCH_MIN_ITEMS = 12
const BATCH_LISTBOX_MAX_HEIGHT = 250
const EMPTY_LIST = []
// Business rule: date filters are limited to a 3-month window unless searching by exact shipment code.
const MAX_DATE_RANGE_MONTHS = 3

/**
 * Converts a Date object to an HTML date input value (YYYY-MM-DD).
 */
const toDateInputValue = (date) => {
  const year = date.getFullYear()
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')
  return `${year}-${month}-${day}`
}

// Initializes default filters and preloads the last 3 months in the date range.
const getInitialFilters = () => {
  const today = new Date()
  const sinceDate = new Date(today)
  sinceDate.setMonth(sinceDate.getMonth() - MAX_DATE_RANGE_MONTHS)

  return {
    shipmentCode: null,
    productCode: [],
    batchId: [],
    emittedSince: toDateInputValue(sinceDate),
    emittedUntil: toDateInputValue(today),
    cancelRequested: false,
    reference: null,
    postalCode: null,
    locality: null,
    who: null,
    streetName: null,
    stateCode: StateCodes.FILTER_CODES.flatMap(p => p.stateCode),
    userId: []
  }
}

let INITAL_FILTERS = getInitialFilters()


/**
 * Class component that represents the shipments list table.
 */

export class OutboxLayout extends React.Component {

  constructor(props) {
    super(props)
    this.cachedAssignedCodesRef = null
    this.cachedTrackingByShipment = {}
    this.cachedFeedbacksRef = null
    this.cachedFeedbacksByShipment = {}
    this.cachedShipmentRows = []
    this.cachedShipmentRowsDeps = null
    this.state = {
      shipments: [],
      assignedCodes: [],
      feedbacks: [],
      statesByShipment: {},

      pagesLoaded: 0,
      endOfShipments: false,
      pageSize: SHIPMENT_PAGE_SIZE,
      totalShipments: 0,
      maxKnownPage: 0,

      isLoading: false,

      // List of shipment selected by user/client
      shipmentsCodesSelected: [],
      checkedAll: true,

      // List of products to filter
      products: [],

      // Product selected in autocomplete filter
      productSelected: [],
      isAllProductsSelected: true,
      productError: null,

      // Filter
      filters: getInitialFilters(),
      open: false,
      
      // Status selected in autocomplete filter
      stateCodeSelected: [],
      isAllStatesSelected: true,

      //users to filter
      users: [],
      usersSelected: [],
      isAllUsersSelected: true,
      usersError: null,
      usersLoading: false,
      usersPage: 0,
      hasMoreUsers: false,

      // batches to filter
      batches: [],
      batchSelected: null,
      batchSearchText: "",
      batchesLoading: false,
      batchesPage: 0,
      hasMoreBatches: false,
    }

    //If a filter is launched and has not yet received a response from a previous call, inconsistencies may appear. Therefore, until a call is finished, the previous one is not launched.
    this.debouncedDoFilter = this.debounce(this.doFilter, 1000); // 1000 ms = 1 second      
    this.debouncedLoadBatches = this.debounce(this.loadBatchesBySearch, 350);
    this.filterInProgress = false;
    this.pendingFilter = false;
  }

  /**
   * It runs after the component output has been rendered to the DOM.
   */
  componentDidMount() {
    this.setState({
      isLoading: true, stateCodeSelected: this.getSortedFilterStates()
    })
    AuthCli.GetSessionInfo().then(session => {
      if (session) {
        this.setState({ session: session }, () => {
          this.getAllProducts()
          const normalizedFilters = this.normalizeShipmentFilters(this.state.filters)
          if (this.state.session.role === Roles.ROLE_USER.Name) {
            this.getShipments(normalizedFilters, true)
            return
          }

          if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
            this.getBillableUsers()
            this.getShipmentsOfBillable(normalizedFilters, true)
            return
          }
        })
      } else {
        this.setState({ isLoading: false })
      }
    })
  }


  /**
   * Loads shipments for regular users and updates related tracking/feedback data.
   */
  
  // ===== Shipments: loading and role-based orchestration =====
  getShipments = async (filters, includeCount = false) => {
  
    if (!this.state.isLoading) this.setState({ isLoading: true })
    if (includeCount) {
      await this.getShipmentsCount(filters)
    }

    await OutboxCli.GetShipments(this.state.pageSize, this.state.pagesLoaded, true, true, false, filters).then(async data => {
      
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ shipmentsError: data.substring(data.indexOf(' ')), isLoading: false })
      } else {
        const shipments = Array.isArray(data) ? data : []
        const shipmentcodes = shipments.map(s => { return s.shipmentCode })
        const shipmentsCodesSelected = this.state.checkedAll ? shipmentcodes : []
        const assignedCodes = shipmentcodes.length > 0 ? await this.getAssignedCodes(shipmentcodes) : []
        const feedbacks = shipmentcodes.length > 0 ? await this.getFeedbackOfShipments(shipmentcodes) : []
        if (feedbacks === null) return
        const statesByShipment = shipmentcodes.length > 0 ? await this.getStatesByShipment(feedbacks) : {}
        if (statesByShipment === null) return

        this.setState({
          shipments: shipments,
          shipmentsCodesSelected: shipmentsCodesSelected,
          assignedCodes: assignedCodes,
          feedbacks: feedbacks,
          statesByShipment: statesByShipment,
          endOfShipments: this.state.pagesLoaded >= this.getMaxPageFromCount(),
          shipmentsError: null,
          isLoading: false
        }, () => {
          const maxKnownPage = this.getMaxPageFromCount()

          if (maxKnownPage !== this.state.maxKnownPage) {
            this.setState({ maxKnownPage: maxKnownPage })
          }
        })
      }
    })
  }

  /**
   * Loads shipments for admin/supervisor users scoped to billable accounts.
   */
  getShipmentsOfBillable = async (filters, includeCount = false) => {
    if (!this.state.isLoading) this.setState({ isLoading: true })
    if (includeCount) {
      await this.getShipmentsCount(filters)
    }
    
    await OutboxCli.GetShipmentsOfBillable(this.state.pageSize, this.state.pagesLoaded, true, true, false, filters).then(async data => {
      
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ shipmentsError: data.substring(data.indexOf(' ')), isLoading: false })
      } else {
        const shipments = Array.isArray(data) ? data : []
        const shipmentcodes = shipments.map(s => { return s.shipmentCode })
        const shipmentsCodesSelected = this.state.checkedAll ? shipmentcodes : []
        const assignedCodes = shipmentcodes.length > 0 ? await this.getAssignedCodes(shipmentcodes) : []
        const feedbacks = shipmentcodes.length > 0 ? await this.getFeedbackOfShipments(shipmentcodes) : []
        if (feedbacks === null) return
        const statesByShipment = shipmentcodes.length > 0 ? await this.getStatesByShipment(feedbacks) : {}
        if (statesByShipment === null) return

        this.setState({
          shipments: shipments,
          shipmentsCodesSelected: shipmentsCodesSelected,
          assignedCodes: assignedCodes,
          feedbacks: feedbacks,
          statesByShipment: statesByShipment,
          endOfShipments: this.state.pagesLoaded >= this.getMaxPageFromCount(),
          shipmentsError: null,
          isLoading: false
        }, () => {
          const maxKnownPage = this.getMaxPageFromCount()

          if (maxKnownPage !== this.state.maxKnownPage) {
            this.setState({ maxKnownPage: maxKnownPage })
          }
        })
      }
    })
  }

  /**
   * Retrieves total shipment count for the current role and updates pagination bounds.
   */
  getShipmentsCount = async (filters) => {
    let response = null
    if (this.state.session.role === Roles.ROLE_USER.Name) {
      response = await OutboxCli.CountShipments(true, true, false, filters)
    } else if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
      response = await OutboxCli.CountShipmentsOfBillable(true, true, false, filters)
    }

    if (response !== null && response !== undefined && response.toString().startsWith("[ERR")) {
      this.setState({ shipmentsError: response.substring(response.indexOf(' ')), totalShipments: 0 })
      return 0
    }

    const total = Number(response)
    const safeTotal = Number.isFinite(total) && total >= 0 ? total : 0

    this.setState({ totalShipments: safeTotal }, () => {
      const maxKnownPage = this.getMaxPageFromCount()
      if (this.state.maxKnownPage !== maxKnownPage) {
        this.setState({ maxKnownPage: maxKnownPage })
      }
    })

    return safeTotal
  }

  /**
   * Dispatches shipment loading based on the authenticated user role.
   */
  loadShipmentsByRole = (filters, includeCount = false) => {
    if (this.state.session.role === Roles.ROLE_USER.Name) {
      return this.getShipments(filters, includeCount)
    }

    if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
      return this.getShipmentsOfBillable(filters, includeCount)
    }

    return Promise.resolve()
  }

  // ===== Filters: normalization and date-range rules =====
  /**
   * Normalizes raw filter values before sending them to backend APIs.
   * - Trims shipment code input.
   * - Disables date filters when searching by shipment code.
   * - Converts date strings into Date objects with end-of-day handling for emittedUntil.
   */
  normalizeShipmentFilters = (filters) => {
    const normalizedFilters = { ...filters }

    const rawShipmentCode = typeof normalizedFilters.shipmentCode === 'string'
      ? normalizedFilters.shipmentCode.trim()
      : normalizedFilters.shipmentCode
    const shipmentCode = rawShipmentCode === '' ? null : rawShipmentCode
    normalizedFilters.shipmentCode = shipmentCode

    // Direct shipment-code searches bypass date filtering constraints.
    if (shipmentCode) {
      normalizedFilters.emittedSince = null
      normalizedFilters.emittedUntil = null
      return normalizedFilters
    }

    if (normalizedFilters.emittedSince && /^\d{4}-\d{2}-\d{2}$/.test(normalizedFilters.emittedSince)) {
      normalizedFilters.emittedSince = new Date(normalizedFilters.emittedSince)
    } else {
      normalizedFilters.emittedSince = null
    }

    if (normalizedFilters.emittedUntil && /^\d{4}-\d{2}-\d{2}$/.test(normalizedFilters.emittedUntil)) {
      const dateTime = new Date(normalizedFilters.emittedUntil)
      dateTime.setHours(23, 59, 59, 999)
      normalizedFilters.emittedUntil = dateTime
    } else {
      normalizedFilters.emittedUntil = null
    }

    return normalizedFilters
  }

  /**
   * Returns true when shipment-code search is active.
   */
  isDirectShipmentSearch = (filters = this.state.filters) => {
    if (!filters) return false
    const shipmentCode = filters.shipmentCode
    if (typeof shipmentCode !== 'string') return !!shipmentCode
    return shipmentCode.trim().length > 0
  }

  /**
   * Parses an HTML date input value (YYYY-MM-DD) into a Date object.
   */
  parseDateInput = (value) => {
    if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null
    const date = new Date(value + "T00:00:00")
    return Number.isNaN(date.getTime()) ? null : date
  }

  /**
   * Validates whether the selected date range exceeds the configured max window.
   */
  isDateRangeExceedingMaxMonths = () => {
    const sinceDate = this.parseDateInput(this.state.filters.emittedSince)
    const untilDate = this.parseDateInput(this.state.filters.emittedUntil)
    if (!sinceDate || !untilDate) return false

    const maxAllowedUntilDate = new Date(sinceDate)
    maxAllowedUntilDate.setMonth(maxAllowedUntilDate.getMonth() + MAX_DATE_RANGE_MONTHS)
    return untilDate > maxAllowedUntilDate
  }

  // =================================================================================
  // PAGINATION (state model + handlers)
  // Internal model: pagesLoaded is 0-based, UI pagination component is 1-based.
  // =================================================================================
  // Computes the last available page index (0-based) from total results and current page size.
  getMaxPageFromCount = () => {
    const total = Number(this.state.totalShipments || 0)
    const pageSize = Number(this.state.pageSize || SHIPMENT_PAGE_SIZE)
    if (total <= 0 || pageSize <= 0) return 0

    return Math.max(Math.ceil(total / pageSize) - 1, 0)
  }

  // Handles page navigation while keeping the current filter set.
  handleChangePage = (newPage) => {
    const maxPage = this.getMaxPageFromCount()
    if (newPage < 0 || newPage > maxPage) return

    const filters = this.normalizeShipmentFilters(this.state.filters)
    this.setState({
      pagesLoaded: newPage,
      checkedAll: true,
      shipmentsCodesSelected: []
    }, () => {
      this.loadShipmentsByRole(filters, false)
    })
  }

  // Updates page size, resets paging to first page, and reloads the current query.
  handleChangeRowsPerPage = (event) => {
    const newPageSize = parseInt(event.target.value, 10)
    const filters = this.normalizeShipmentFilters(this.state.filters)
    this.setState({
      pageSize: Number.isFinite(newPageSize) ? newPageSize : SHIPMENT_PAGE_SIZE,
      pagesLoaded: 0,
      maxKnownPage: 0,
      checkedAll: true,
      shipmentsCodesSelected: []
    }, () => {
      this.loadShipmentsByRole(filters, false)
    })
  }

  // ===== Shipments: enrichments and filter datasets =====
  /**
   * Retrieves assigned tracking codes for a list of shipment codes.
   */
  getAssignedCodes = async (shipmentcodes) => {
    let assignedCodes = []
    await CycleCli.GetAssignedCodes(shipmentcodes).then(response => {
      
      if (response !== null && response.toString().startsWith("[ERR")) {
        assignedCodes = null
        this.setState({ shipmentsError: response, isLoading: false })
      } else {
        let filtered = response.filter(d => d !== null && d.codeValue !== "" && d.codeType === 'CODE_TRACKING')
        assignedCodes = filtered
      }
    })
    return assignedCodes
  }

  /**
   * Retrieves feedback entries associated with a list of shipments.
   */
  getFeedbackOfShipments = async (shipmentcodes) => {
    let feedbacks = null
    await InboxCli.GetFeedbackOfShipments(shipmentcodes, true, true, true, true, true).then(response => {
      if (!Array.isArray(response)) {
        const error = typeof response === "string" && response.startsWith("[ERR")
          ? response.substring(response.indexOf(' '))
          : "[ERR] Unable to retrieve shipment feedback: invalid response"
        this.setState({ shipmentsError: error, isLoading: false })
      } else {
        feedbacks = response
      }
    })
    return feedbacks
  }

  /**
   * Retrieves shipment states in bulk and groups them by shipment code.
   */
  getStatesByShipment = async (feedbacks) => {
    const stateReturnIds = (feedbacks || [])
      .filter(f => f && f.returnType === InboxCli.RETURN_STAGE_STATE && f.returnId)
      .map(f => f.returnId)

    if (stateReturnIds.length === 0) return {}

    const response = await InboxCli.GetStates(stateReturnIds)
    if (response !== null && response.toString().startsWith("[ERR")) {
      this.setState({ shipmentsError: response.substring(response.indexOf(' ')), isLoading: false })
      return null
    }

    const states = (Array.isArray(response) ? response : []).map(st => {
      if (!st) return st

      const temp = Object.assign({}, st)
      let parsedStateData = temp.stateData
      if (typeof parsedStateData === "string" && parsedStateData.trim() !== "") {
        try {
          parsedStateData = JSON.parse(parsedStateData)
        } catch (parseError) {
          parsedStateData = {}
        }
      }
      temp.stateData = parsedStateData || {}
      return temp
    })

    const grouped = {}
    states.forEach(state => {
      if (!state || state.stage === InboxCli.RETURN_STAGE_RETURN) return
      if (!state.shipmentCode) return
      if (!grouped[state.shipmentCode]) grouped[state.shipmentCode] = []
      grouped[state.shipmentCode].push(state)
    })

    Object.keys(grouped).forEach(shipmentCode => {
      grouped[shipmentCode].sort((a, b) => {
        const aTime = new Date(a.timestamp).getTime()
        const bTime = new Date(b.timestamp).getTime()
        const safeATime = Number.isNaN(aTime) ? 0 : aTime
        const safeBTime = Number.isNaN(bTime) ? 0 : bTime
        return safeATime - safeBTime
      })
    })

    return grouped
  }


  // Getting list of products
  getAllProducts = async () => {
    ProductCli.GetAllProducts().then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ productError: response.substring(response.indexOf(' ')) })
      } else {
        const sortedProducts = Array.isArray(response)
          ? [...response].sort((a, b) => (a.description || '').localeCompare((b.description || ''), 'es', { sensitivity: 'base' }))
          : []

        this.setState({ products: sortedProducts, productSelected: sortedProducts, productError: null })
      }
    })
  }

  /**
   * Loads billable users and then refreshes available batches based on selected users.
   */
  getBillableUsers = () => {
    this.loadBillableUsersPage(true)
  }

  /**
   * Loads users page by page for admin/supervisor filters.
   */
  loadBillableUsersPage = async (reset = false) => {
    if (this.state.usersLoading) return

    const page = reset ? 0 : this.state.usersPage
    const previousUsersCount = reset ? 0 : this.state.users.length
    this.setState({ usersLoading: true })

    const response = await AuthCli.GetBillableUsers(USERS_PAGE_SIZE, page)
    if (response !== null && response.toString().startsWith("[ERR")) {
      this.setState({ usersError: response.substring(response.indexOf(' ')), usersLoading: false })
      return
    }

    const incoming = (Array.isArray(response) ? response : []).filter(element => element !== undefined)

    const mergedUsers = reset ? incoming : [...this.state.users, ...incoming]
    const usersById = new Map()
    mergedUsers.forEach(user => {
      if (!user || !user.userId) return
      usersById.set(user.userId, user)
    })
    const dedupedUsers = [...usersById.values()].sort(this.GetSortOrder("userEmail"))
    const hasMoreUsers = incoming.length === USERS_PAGE_SIZE

    this.setState(previousState => {
      const selectedIds = new Set((previousState.usersSelected || []).map(u => u.userId))
      const usersSelected = previousState.isAllUsersSelected
        ? dedupedUsers
        : dedupedUsers.filter(user => selectedIds.has(user.userId))

      return {
        users: dedupedUsers,
        usersSelected: usersSelected,
        usersError: null,
        usersLoading: false,
        usersPage: page + 1,
        hasMoreUsers: hasMoreUsers
      }
    }, () => {
      // If the menu cannot scroll yet but backend still has pages, prefetch once more.
      const usersIncreased = dedupedUsers.length > previousUsersCount
      const shouldAutoprefetch = hasMoreUsers && usersIncreased && dedupedUsers.length < AUTOPREFETCH_MIN_ITEMS
      if (shouldAutoprefetch) {
        this.loadBillableUsersPage(false)
      }
    })
  }

  /**
   * Lazy-loads users when opening the users multi-select.
   */
  handleUsersOpen = () => {
    if (this.state.users.length > 0 || this.state.usersLoading) return
    this.loadBillableUsersPage(true)
  }

  /**
   * Loads next users page when users dropdown is scrolled to bottom.
   */
  handleUsersScroll = (event) => {
    const listNode = event.currentTarget
    const reachedBottom = listNode.scrollTop + listNode.clientHeight >= listNode.scrollHeight - 8
    if (reachedBottom && this.state.hasMoreUsers && !this.state.usersLoading) {
      this.loadBillableUsersPage(false)
    }
  }

  
  // ===== Batches: autocomplete data and infinite scroll =====
  /**
   * Loads batches available for the current user and keeps the selected batch consistent.
   */
  getBatchesByUser = (userId, searchText = null, pageSize = BATCH_PAGE_SIZE, page = 0) => {
    return OutboxCli.GetBatchesByUser(userId, searchText, pageSize, page)
  }

  /**
   * Loads batches for billable users using user filters and keeps batch selection valid.
   */
  getBatchesOfBillable = (userIdFilter, searchText = null, pageSize = BATCH_PAGE_SIZE, page = 0) => {
    const filter = {
      userIdFilter: userIdFilter && userIdFilter.length > 0 ? userIdFilter : [],
      searchText: searchText,
      pageSize: pageSize,
      page: page
    }

    return OutboxCli.GetBatchesOfBillable(filter)
  }

  /**
   * Trims and normalizes batch search text before API calls.
   */
  normalizeBatchSearchText = (searchText) => {
    const normalized = (searchText || "").toString().trim()
    return normalized === "" ? null : normalized
  }

  /**
   * Resets batch-related UI/filter state and optionally reloads the first page.
   */
  invalidateBatches = (reload = false) => {
    this.setState(previousState => ({
      batches: [],
      batchSelected: null,
      batchSearchText: "",
      batchesLoading: false,
      batchesPage: 0,
      hasMoreBatches: false,
      filters: {
        ...previousState.filters,
        batchId: []
      }
    }), () => {
      if (reload) this.loadBatchesPage(true, "")
    })
  }

  /**
   * Starts a fresh batch search from page zero.
   */
  loadBatchesBySearch = (searchText) => {
    this.loadBatchesPage(true, searchText)
  }

  /**
   * Loads one page of batch results, merges them, and keeps selection consistency.
   */
  loadBatchesPage = async (reset = false, searchText = this.state.batchSearchText) => {
    if (!this.state.session || this.state.batchesLoading) return

    const previousBatchesCount = reset ? 0 : this.state.batches.length
    const normalizedSearchText = this.normalizeBatchSearchText(searchText)
    const page = reset ? 0 : this.state.batchesPage

    this.setState({ batchesLoading: true })

    const response = this.state.session.role === Roles.ROLE_USER.Name
      ? await this.getBatchesByUser(this.state.session.userId, normalizedSearchText, BATCH_PAGE_SIZE, page)
      : await this.getBatchesOfBillable(this.state.filters.userId, normalizedSearchText, BATCH_PAGE_SIZE, page)

    if (response !== null && response.toString().startsWith("[ERR")) {
      this.setState({ batchesLoading: false })
      return
    }

    const incoming = Array.isArray(response) ? response : []
    const merged = reset ? incoming : [...this.state.batches, ...incoming]
    const deduped = merged.filter((item, index, arr) => arr.findIndex(x => x.batchId === item.batchId) === index)
    const hasMoreBatches = incoming.length === BATCH_PAGE_SIZE
    const selectedBatch = this.state.batchSelected
    const selectedStillPresent = selectedBatch ? deduped.some(b => b.batchId === selectedBatch.batchId) : true

    this.setState(previousState => ({
      batches: deduped,
      batchSearchText: searchText || "",
      batchesPage: page + 1,
      hasMoreBatches: hasMoreBatches,
      batchesLoading: false,
      batchSelected: selectedStillPresent ? previousState.batchSelected : null,
      filters: selectedStillPresent ? previousState.filters : {
        ...previousState.filters,
        batchId: []
      }
    }), () => {
      const dedupedIncreased = deduped.length > previousBatchesCount
      const shouldAutoprefetch = hasMoreBatches && dedupedIncreased && deduped.length < AUTOPREFETCH_MIN_ITEMS
      if (shouldAutoprefetch) {
        this.loadBatchesPage(false, searchText || "")
      }
    })
  }

  /**
   * Lazy-loads batch options the first time the autocomplete is opened.
   */
  handleBatchesOpen = () => {
    if (this.state.batches.length > 0 || this.state.batchesLoading) return
    this.loadBatchesPage(true, this.state.batchSearchText)
  }

  // ===== Shipments: row actions (cancel/remove) =====
  /**
   Removes or cancels a shipment owned by the calling user.
   For not yet emitted shipments: the shipment is completely removed from the user's collection as if never stored.
   For emitted but not processed shipments: the shipment is completely removed and the price refund to the user.
   For processed shipments: the shipment is flagged as canceled.
  **/
  removeOrCancelShipment = (shipment, onlyCancel, removeDraft) => {
       
    if (onlyCancel) {
      if (shipment.cancelTime) return
      // Flag the shipment as canceled now.
      shipment.cancelTime = DateCustom.convertToUtcDate(new Date(), 0)
      this.setState({ isLoading: true })
      this.cancelShipment(shipment).finally(() => {
        this.setState({ isLoading: false })
      })
      return

    } else {
      if (this.state.session.role === Roles.ROLE_USER.Name) {
        this.removeShipment(shipment, removeDraft)
        return
      }

      if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
        this.removeShipmentOfBillable(shipment, removeDraft)
        return
      }
    }
  }
  
  /**
   * Cancels a shipment by storing it with a cancel timestamp.
   */
  cancelShipment = (shipment) => {
    shipment.cancelTime = DateCustom.convertToUtcDate(new Date(), 0)
    return OutboxCli.StoreShipment(shipment, null).then(shipmentId => {
      if (shipmentId.toString().startsWith('[ERR')) {
        shipment.cancelTime = null
        this.setState({ shipmentRemoveError: shipmentId.substring(shipmentId.indexOf(' ')) })
      } else {
        let shipments = this.state.shipments.map(s => {
          if (s.shipmentId === shipmentId.shipmentId) {
            return shipmentId
          } else {
            return s
          }
        })
        let shipmentRemoveError = null
        if (!shipmentId.cancelTime) shipmentRemoveError = localizer.OutboxNotBeCanceled
        this.setState({ shipments: shipments, shipmentRemoveError: shipmentRemoveError })
      }
    })
  }

  /**
   * Removes a shipment for regular users and updates local counters/selections.
   */
  removeShipment = (shipment, removeDraft, doNotCancel) => {
    this.setState({ isLoading: true })
    OutboxCli.RemoveShipment(shipment.shipmentId, removeDraft, doNotCancel).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ shipmentRemoveError: data.substring(data.indexOf(' ')) })
      } else {
        let shipments = this.state.shipments.filter(s => s.shipmentId !== shipment.shipmentId)
        this.setState(previousState => ({
          shipments: shipments,
          shipmentRemoveError: null,
          totalShipments: Math.max((previousState.totalShipments || 0) - 1, 0)
        }),
          () => {
            let shipmentcodes = []
            if (this.state.checkedAll) shipmentcodes = this.state.shipments.map(s => { return s.shipmentCode })
            this.setState({ shipmentsCodesSelected: shipmentcodes })
          })
      }
    }).finally(() => {
      this.setState({ isLoading: false })
    })
  }

  /**
   * Removes a shipment for billable users and updates local counters/selections.
   */
  removeShipmentOfBillable = (shipment, removeDraft, doNotCancel) => {
    this.setState({ isLoading: true })
    OutboxCli.RemoveShipmentOfBillable(shipment.shipmentId, removeDraft, doNotCancel).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ shipmentRemoveError: data.substring(data.indexOf(' ')) })
      } else {
        let shipments = this.state.shipments.filter(s => s.shipmentId !== shipment.shipmentId)
        this.setState(previousState => ({
          shipments: shipments,
          shipmentRemoveError: null,
          totalShipments: Math.max((previousState.totalShipments || 0) - 1, 0)
        }),
          () => {
            let shipmentcodes = []
            if (this.state.checkedAll) shipmentcodes = this.state.shipments.map(s => { return s.shipmentCode })
            this.setState({ shipmentsCodesSelected: shipmentcodes })
          })
      }
    }).finally(() => {
      this.setState({ isLoading: false })
    })
  }

  /**
   * Closes active snackbars by clearing current error messages.
   */
  handleonClose = () => {
    this.setState({ shipmentsError: null, shipmentRemoveError: null, productError: null, usersError: null })
  }
  
  // ===== Selection: table and row checkbox handling =====
  /** Adds or removes all shipment codes to shipment codes selected list */
  onChangeSelectAll = (event) => {
    this.setState({ [event.target.name]: event.target.checked }, () => {
      let shipmentcodes = []
      if (this.state.checkedAll) shipmentcodes = this.state.shipments.map(s => { return s.shipmentCode })
      this.setState({ shipmentsCodesSelected: shipmentcodes })
    })
  }

  /**
   * Adding/Removing a shipment code to shipment codes selected list when row checkbox is checked/unchecked
   * @param {*} shipmentcode code of the shipment to add/remove
   * @param {*} option CHECKED/UNCHECKED option to determinate if the action to apply is add or remove
   */
  addOrRemoveSelectedShipment = (shipmentcode, option) => {
    let shipmentsCodesSelected = [...this.state.shipmentsCodesSelected]
    if (option === 'CHECKED') {
      shipmentsCodesSelected.push(shipmentcode)
    } else {
      shipmentsCodesSelected = shipmentsCodesSelected.filter(shipmentCode => shipmentCode !== shipmentcode)
    }
    this.setState({ shipmentsCodesSelected: shipmentsCodesSelected })
  }

  // ===== Filters: UI handlers =====
   
  handleChangeProduct = async (event) => {
    let valChecked = event.currentTarget.dataset.modal
    if (valChecked === "allProducts") {
      let productSelected = this.state.isAllProductsSelected ? [] : this.state.products
      let productsCodesSelected = this.state.isAllProductsSelected ? [] : this.state.products.map(p => p.productCode);
      this.setState({
        productSelected: productSelected, isAllProductsSelected: !this.state.isAllProductsSelected,
      })
      
      this.setState(previousState => ({
        filters: {
          ...previousState.filters,
          productCode: productsCodesSelected
        }
      }));
      
    } else {
      const item = this.state.products.find(p => p.productCode === valChecked)
      if (!item) return
      let checked = this.state.productSelected.some(p => p.productCode === valChecked)
      let productSelected = [...this.state.productSelected]
      
      if (checked) {
        productSelected = productSelected.filter(p => p.productCode !== valChecked)
      } else {
        productSelected.push(item)
      }
      let productsCodesSelected = productSelected.map(p => p.productCode);

      //checks if the user has unchecked/checked the last one he had checked/unchecked to put the "check all" accordingly
      let isAllProductsSelected = this.state.isAllProductsSelected
      if (this.state.products.length === productSelected.length && productSelected.length > 0) isAllProductsSelected = true
      if (productSelected.length === 0) isAllProductsSelected = false
      
      this.setState(previousState => ({
        filters: {
          ...previousState.filters,
          productCode: productsCodesSelected
        },
        productSelected: productSelected,
        isAllProductsSelected: isAllProductsSelected,
      }));
    }
  }
  
  handleChangeStatus = (event) => {
    let valChecked = event.currentTarget.dataset.modal;
    if (valChecked === "allStates") {
      let stateCodeSelected = this.state.isAllStatesSelected ? [] : this.getSortedFilterStates();
      let stateCodeSelectedCodes = this.state.isAllStatesSelected ? [] : StateCodes.FILTER_CODES.flatMap(p => p.stateCode);

      this.setState(previousState => ({
        filters: {
          ...previousState.filters,
          stateCode: stateCodeSelectedCodes
        },
        stateCodeSelected: stateCodeSelected,
        isAllStatesSelected: !this.state.isAllStatesSelected,
      }));

    } else {
      
      let item = StateCodes.FILTER_CODES.find(s => s.stateCode.join(',') === valChecked);
      let stateCodeSelected = [...this.state.stateCodeSelected];
      let stateCodeSelectedCodes = [...this.state.filters.stateCode];

      if (item) {
        if (stateCodeSelected.some(s => s.stateCode.join(',') === valChecked)) {
          stateCodeSelected = stateCodeSelected.filter(p => p.stateCode.join(',') !== valChecked);
          stateCodeSelectedCodes = stateCodeSelectedCodes.filter(code => !item.stateCode.includes(code));
        } else {
          stateCodeSelected.push(item);
          stateCodeSelectedCodes.push(...item.stateCode);
        }
      }

      let isAllStatesSelected = StateCodes.FILTER_CODES.flatMap(p => p.stateCode).length === stateCodeSelectedCodes.length;

      this.setState(previousState => ({
        filters: {
          ...previousState.filters,
          stateCode: stateCodeSelectedCodes
        },
        isAllStatesSelected: isAllStatesSelected, stateCodeSelected: stateCodeSelected,
      }));
    }
  }

  handleChangeUser = async (event) => {
    let valChecked = event.currentTarget.dataset.modal
    if (valChecked === "allUsers") {
      let usersSelected = this.state.isAllUsersSelected ? [] : this.state.users
      let usersIdSelected = this.state.isAllUsersSelected ? [] : this.state.users.map(p => p.userId);
      this.setState({
        usersSelected: usersSelected, isAllUsersSelected: !this.state.isAllUsersSelected,
      })
      
      this.setState(previousState => ({
        filters: {
          ...previousState.filters,
          userId: usersIdSelected
        }
      }), () => {
        this.invalidateBatches(this.state.batches.length > 0)
      });
      
    } else {
      const item = this.state.users.find(p => p.userId === valChecked)
      if (!item) return
      let checked = this.state.usersSelected.some(p => p.userId === valChecked)
      let usersSelected = [...this.state.usersSelected]
      
      if (checked) {
        usersSelected = usersSelected.filter(p => p.userId !== valChecked)
      } else {
        usersSelected.push(item)
      }
     
      let usersIdSelected = usersSelected.map(p => p.userId);
      
      //checks if the user has unchecked/checked the last one he had checked/unchecked to put the "check all" accordingly
      let isAllUsersSelected = this.state.isAllUsersSelected
      if (this.state.users.length === usersSelected.length && usersSelected.length > 0) isAllUsersSelected = true
      if (usersSelected.length === 0) isAllUsersSelected = false
      
      this.setState(previousState => ({
        filters: {
          ...previousState.filters,
          userId: usersIdSelected
        },
        usersSelected: usersSelected,
        isAllUsersSelected: isAllUsersSelected,
      }), () => {
        this.invalidateBatches(this.state.batches.length > 0)
      });
    }
  }

  /**
   * Updates the selected batch filter from the batches dropdown.
   */
  handleChangeBatch = (event, value) => {
    this.setState(previousState => ({
      batchSelected: value,
      filters: {
        ...previousState.filters,
        batchId: value && value.batchId ? [value.batchId] : []
      }
    }))
  }

  /**
   * Triggers debounced server-side search while typing in batch autocomplete.
   */
  handleBatchInputChange = (event, value, reason) => {
    if (reason !== "input") return
    this.setState({ batchSearchText: value || "" })
    this.debouncedLoadBatches(value || "")
  }

  /**
   * Triggers infinite-scroll loading when batch list reaches the bottom.
   */
  handleBatchScroll = (event) => {
    const listboxNode = event.currentTarget
    const reachedBottom = listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 8
    if (reachedBottom && this.state.hasMoreBatches && !this.state.batchesLoading) {
      this.loadBatchesPage(false, this.state.batchSearchText)
    }
  }

  /**
   * Formats a batch creation date for display.
   */
  formatBatchDate = (createdAtUtc) => {
    if (!createdAtUtc) return ""
    const date = new Date(createdAtUtc)
    if (Number.isNaN(date.getTime())) return ""
    return date.toLocaleDateString("es-ES")
  }

  /**
   * Builds the display label for a batch, including date and owner when applicable.
   */
  formatBatchText = (batch) => {
    if (!batch) return ""

    const label = batch.label && batch.label.trim() !== '' ? batch.label.trim() : batch.batchId
    const dateText = this.formatBatchDate(batch.createdAtUtc)
    const baseText = dateText ? (label + " - " + dateText) : label

    if (!this.state.session) return baseText
    if (this.state.session.role === Roles.ROLE_USER.Name) return baseText

    const currentUserId = this.state.session.userId || ""
    const ownerUserId = batch.ownerUserId || ""
    const ownerIsCurrentUser = currentUserId !== "" && ownerUserId !== "" && currentUserId === ownerUserId
    if (ownerIsCurrentUser) return baseText

    const ownerUser = batch.ownerUser && batch.ownerUser.trim() !== '' ? batch.ownerUser.trim() : ""
    return ownerUser ? (baseText + " - " + ownerUser) : baseText
  }

  onInputChange = (event) => {
    const { name: inputName, value: inputValue, type: inputType } = event.target;
    let value = inputValue || '';
    let newFilters = { ...this.state.filters };
  
    if (inputType === "date") {
      newFilters[inputName] = value;
    } else if (inputType === "checkbox") {
      newFilters.cancelRequested = !this.state.filters.cancelRequested;
    } else {
      newFilters[inputName] = value;
    }
  
    // If the input is a checkbox or the inputName is 'reference', call debouncedDoFilter
    this.setState({ filters: newFilters }, (inputType === "checkbox" || inputName === "reference") ? this.debouncedDoFilter : undefined);
  }
  /**
   * delay execution,
   * @param func function to execute
   * @param wait time to wait
   */
  debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  /** Conditions for those shipments to be included 
   * If the user pauses and then continues typing, the current call will complete and then a new call will be executed with the updated value. This ensures that the most recent value is always used
  */
  doFilter = () => {
    // Allow direct shipment searches even when date range exceeds the 3-month limit.
    const bypassDateRangeLimit = this.isDirectShipmentSearch()
    // Block filtering only when the date window is invalid and no shipment code is provided.
    if (this.isDateRangeExceedingMaxMonths() && !bypassDateRangeLimit) return

    if (this.filterInProgress) {
      this.pendingFilter = true;
      return; //If a call is already in progress, do nothing
    }
  
    this.filterInProgress = true;
    this.pendingFilter = false;
  
    this.setState({
      pagesLoaded: 0,
      endOfShipments: false,
      checkedAll: true,
      shipments: [],
      shipmentsCodesSelected: [],
      totalShipments: 0,
      maxKnownPage: 0
    }, () => {
  
      const filters = this.normalizeShipmentFilters(this.state.filters)
  
      const callback = () => {
        this.filterInProgress = false;
        if (this.pendingFilter) {
          this.doFilter();
        }
      };

      this.loadShipmentsByRole(filters, true).finally(callback)
    });
  }

  /** List of shipment will be reset after clean all filter values */
  doCleanFilters = () => {
    INITAL_FILTERS = getInitialFilters()
    this.setState({
      filters: getInitialFilters(), productSelected: this.state.products,
      stateCodeSelected: this.getSortedFilterStates(),
      stateCodeSelectedCodes: StateCodes.FILTER_CODES.flatMap(p => p.stateCode), pagesLoaded: 0,
      endOfShipments: false, checkedAll: true, shipments: [], shipmentsCodesSelected: [], totalShipments: 0, maxKnownPage: 0,
      isAllProductsSelected: true, isAllStatesSelected: true,
      usersSelected: this.state.users, isAllUsersSelected: true,
      batches: [], batchSelected: null, batchSearchText: "", batchesLoading: false, batchesPage: 0, hasMoreBatches: false,
    }, () => {
      const filters = this.normalizeShipmentFilters(this.state.filters)
      
      this.loadShipmentsByRole(filters, true)
    })

  }

  /**
  * Set the state open / collapsed of Collapse filter elements .
  */
  setOpen = () => {
    this.setState({ open: !this.state.open })
  }

  // ===== Exports: downloads and reports =====
  /**
   * Download a .zip with the information of return of shipments selected by user
   * @returns 
   */
  downloadShipmentsReturns = () => {
    const selectedCount = this.state.shipmentsCodesSelected.length
    if (selectedCount > MAX_SHIPMENTS_TO_DOWNLOAD) {
      // Keep the client-side selection flexible, but avoid a request the API will reject.
      this.setState({
        shipmentsError: localizer.formatString(localizer.OutboxDownloadLimitExceeded, MAX_SHIPMENTS_TO_DOWNLOAD, selectedCount)
      })
      return
    }

    if (this.state.session.role === Roles.ROLE_USER.Name) {
      this.downloadFeedbackOfShipments()
      return
    }

    if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
      this.downloadFeedbackOfShipmentsOfBillable()
      return
    }
  }

  /**
   * Downloads returns feedback ZIP for selected shipments (regular user flow).
   */
  downloadFeedbackOfShipments = () => {
    this.setState({ isLoading: true })
    InboxCli.DownloadFeedbackOfShipments(this.state.shipmentsCodesSelected, true, false, true, true, true, true).then((error) => {
      if (error) this.setState({ shipmentsError: error.substring(error.indexOf(' ')) })
      else this.setState({ shipmentsError: null })
    }).finally(() => {
      this.setState({ isLoading: false })
    })
  }

  /**
   * Downloads returns feedback ZIP for selected shipments (billable user flow).
   */
  downloadFeedbackOfShipmentsOfBillable = () => {
    this.setState({ isLoading: true })
    InboxCli.DownloadFeedbackOfShipmentsOfBillable(this.state.shipmentsCodesSelected, true, false, true, true, true, true).then((error) => {
      if (error) this.setState({ shipmentsError: error.substring(error.indexOf(' ')) })
      else this.setState({ shipmentsError: null })
    }).finally(() => {
      this.setState({ isLoading: false })
    })
  }

  /**
   * Download to xlsx with the information of shipments selected by user
   * @returns 
   */
  downloadExcel = () => {
    let filters = { ...this.state.filters }
        
    if (filters.emittedSince && filters.emittedUntil) {
      let dateTime = new Date(filters.emittedUntil)
      dateTime.setDate(dateTime.getDate() + 1)
      dateTime.setMinutes(dateTime.getMinutes() - 1)
      filters.emittedUntil = dateTime
    }
    
    if (this.state.session.role === Roles.ROLE_USER.Name) {
      this.downloadShipmentsExcel(filters)
      return
    }

    if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
      this.downloadShipmentsOfBillableExcel(filters)
      return
    }
  }

  /**
   * Downloads shipments report in Excel format for regular users.
   */
  downloadShipmentsExcel = async (filters) => {
    this.setState({ isLoading: true })
    await ReportCli.DownloadShipmentsReport(true, true, false, filters).then((error) => {
      if (error) this.setState({ shipmentsError: error.substring(error.indexOf(' ')) })
      else this.setState({ shipmentsError: null })
    }).finally(() => {
      this.setState({ isLoading: false })
    })
  }

  /**
   * Downloads shipments report in Excel format for admin/supervisor billable scope.
   */
  downloadShipmentsOfBillableExcel = async (filters) => {
    this.setState({ isLoading: true })
    await ReportCli.DownloadShipmentsReportOfBillable(true, true, false, filters).then((error) => {
      if (error) this.setState({ shipmentsError: error.substring(error.indexOf(' ')) })
      else this.setState({ shipmentsError: null })
    }).finally(() => {
      this.setState({ isLoading: false })
    })
  }

  // ===== Generic helpers =====
  /**
   * Sort array of JSON objects based on an attribute
   */
  GetSortOrder(prop) {
    return function (a, b) {
      if (a[prop] > b[prop]) {
        return 1;
      } else if (a[prop] < b[prop]) {
        return -1;
      }
      return 0;
    }
  }

  /**
   * Returns a sorted copy of available state filters without mutating source constants.
   */
  getSortedFilterStates = () => {
    return [...StateCodes.FILTER_CODES].sort(this.GetSortOrder("name"))
  }

  /**
   * Builds and memoizes a tracking lookup keyed by shipment code.
   * Reuses the previous lookup while assignedCodes keeps the same reference.
   */
  getTrackingByShipmentLookup = () => {
    const assignedCodes = this.state.assignedCodes || []
    if (this.cachedAssignedCodesRef === assignedCodes) {
      return this.cachedTrackingByShipment
    }

    this.cachedAssignedCodesRef = assignedCodes
    this.cachedTrackingByShipment = assignedCodes.reduce((acc, item) => {
      const shipmentCode = item && item.shipmentCode
      if (!shipmentCode) return acc
      if (!acc[shipmentCode]) acc[shipmentCode] = []
      acc[shipmentCode].push(item)
      return acc
    }, {})

    return this.cachedTrackingByShipment
  }

  /**
   * Builds and memoizes a feedback lookup keyed by shipment code.
   * Reuses the previous lookup while feedbacks keeps the same reference.
   */
  getFeedbacksByShipmentLookup = () => {
    const feedbacks = this.state.feedbacks || []
    if (this.cachedFeedbacksRef === feedbacks) {
      return this.cachedFeedbacksByShipment
    }

    this.cachedFeedbacksRef = feedbacks
    this.cachedFeedbacksByShipment = feedbacks.reduce((acc, item) => {
      const shipmentCode = item && item.shipmentCode
      if (!shipmentCode) return acc
      if (!acc[shipmentCode]) acc[shipmentCode] = []
      acc[shipmentCode].push(item)
      return acc
    }, {})

    return this.cachedFeedbacksByShipment
  }

  /**
   * Builds shipment row components and memoizes the rendered list.
   * Recomputes only when tracked dependencies change by reference.
   */
  getShipmentRows = (trackingByShipment, feedbacksByShipment, statesByShipment) => {
    const shipments = this.state.shipments || EMPTY_LIST
    const currentRole = this.state.session ? this.state.session.role : null
    const currentUser = this.state.session ? this.state.session.userEmail : null

    const nextDeps = {
      shipments,
      trackingByShipment,
      feedbacksByShipment,
      statesByShipment,
      products: this.state.products,
      role: currentRole,
      currentUser,
      shipmentsCodesSelected: this.state.shipmentsCodesSelected,
      checkedAll: this.state.checkedAll
    }

    const prevDeps = this.cachedShipmentRowsDeps
    const depsUnchanged = prevDeps &&
      prevDeps.shipments === nextDeps.shipments &&
      prevDeps.trackingByShipment === nextDeps.trackingByShipment &&
      prevDeps.feedbacksByShipment === nextDeps.feedbacksByShipment &&
      prevDeps.statesByShipment === nextDeps.statesByShipment &&
      prevDeps.products === nextDeps.products &&
      prevDeps.role === nextDeps.role &&
      prevDeps.currentUser === nextDeps.currentUser &&
      prevDeps.shipmentsCodesSelected === nextDeps.shipmentsCodesSelected &&
      prevDeps.checkedAll === nextDeps.checkedAll

    if (depsUnchanged) {
      return this.cachedShipmentRows
    }

    this.cachedShipmentRowsDeps = nextDeps
    this.cachedShipmentRows = shipments.map((shipment) => {
      const trackings = trackingByShipment[shipment.shipmentCode] || EMPTY_LIST
      return (
        <ShipmentRow key={shipment.shipmentCode}
          removeOrCancelShipment={this.removeOrCancelShipment}
          shipment={shipment}
          feedbacks={feedbacksByShipment[shipment.shipmentCode] || EMPTY_LIST}
          states={statesByShipment[shipment.shipmentCode] || EMPTY_LIST}
          products={this.state.products}
          role={currentRole}
          currentUser={currentUser}
          shipmentsCodesSelected={this.state.shipmentsCodesSelected}
          checked={this.state.checkedAll}
          addOrRemoveSelectedShipment={this.addOrRemoveSelectedShipment}
          trackings={trackings} />
      )
    })

    return this.cachedShipmentRows
  }

  /**
   * Renders the outbox list, filters, and pagination controls.
   */
  render() {
    // Build O(1) lookup maps by shipmentCode to avoid filtering arrays for each rendered row.
    // Lookups are memoized by source-array reference to keep child props stable while typing.
    const trackingByShipment = this.getTrackingByShipmentLookup()
    const feedbacksByShipment = this.getFeedbacksByShipmentLookup()
    const statesByShipment = this.state.statesByShipment || {}

    const emittedSince = this.state.filters.emittedSince || '';
    const emittedUntil = this.state.filters.emittedUntil || '';
    const isDateRangeExceedingMaxMonths = this.isDateRangeExceedingMaxMonths()
    const hasDirectShipmentCodeSearch = this.isDirectShipmentSearch()
    const isDateRangeBlocked = isDateRangeExceedingMaxMonths && !hasDirectShipmentCodeSearch
    const disabledbuttondownload = this.state.shipmentsCodesSelected.length > 0 ? false : true
    // Material-UI pagination works with 1-based pages, while internal state uses 0-based index.
    const totalPages = Math.max(this.getMaxPageFromCount() + 1, 1)
    const currentPage = Math.min(this.state.pagesLoaded + 1, totalPages)
    const shipmentRows = this.getShipmentRows(trackingByShipment, feedbacksByShipment, statesByShipment)
    
    return (
      <React.Fragment>
        <Container maxWidth="xl">
          
          {/* Screen heading. */}
          <ScreenHeading className="typography-generic"
            icon={<i className="fa-solid fa-boxes-packing icon-button-header mr-20 ml-20"></i>}
            title={localizer.Shipments}
            button={<Button className="button-generic secondary-header" style={{ top: "calc(50% - 20px)" }} variant="contained" component={Link} to="/shipment" startIcon={<i className="fa-solid fa-paper-plane"></i>}>
              {localizer.NewShipment}
            </Button>}
          />

          <GridHeaderFilter container direction="row" justify="center" alignItems="center" style={{ borderRadius: "5px 5px 5px 5px" }}>
            <Grid item container direction="row">
              <Grid item md={6} className="text-align-left">
                <Typography className="typography-generic bigweight text-align-left">{localizer.FindShipments}</Typography>
              </Grid>
              <Grid item md={6} className=" text-align-right">
                <Button id="btfilter" className="button-generic filter" variant="outlined" onClick={this.doFilter} disabled={isDateRangeBlocked} startIcon={<i className="fa-solid fa-filter"></i>}>
                  {localizer.Filter}
                </Button>
                <Button className="button-generic filter" variant="outlined" onClick={this.doCleanFilters} startIcon={<i className="fa-solid fa-broom"></i>}>
                  {localizer.CleanFilter}
                </Button>
              </Grid>
            </Grid>
            
            <Grid container item md={12} spacing={2}>
              <Grid item md={this.state.session && (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) ? 2 : 4}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container spacing={1} alignItems="center" wrap="nowrap">
                    <Grid item xs={6}>
                      <TextFieldStyled className="bg-white" variant='standard' style={{ height: '35px', borderRadius: 0, borderStyle: 'solid', borderWidth: '0.5px', borderColor: '#c2c0c0' }}
                        id="emittedSince" name="emittedSince" fullWidth
                        onChange={this.onInputChange} type="date"
                        value={emittedSince}
                        disabled={hasDirectShipmentCodeSearch}
                        label={<Typography className="typography-generic mt-5neg">{localizer.Since}</Typography>}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          disableUnderline: true,
                          classes: {
                            input: "typography-generic color-gray mr-10 ml-10 mt-12neg"
                          },
                          inputProps: {
                            max: "9999-12-31"
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextFieldStyled className="bg-white" style={{ height: '35px', borderRadius: 0, borderStyle: 'solid', borderWidth: '0.5px', borderColor: '#c2c0c0' }}
                        id="emittedUntil" name="emittedUntil" onChange={this.onInputChange} type="date"
                        value={emittedUntil} fullWidth
                        disabled={hasDirectShipmentCodeSearch}
                        label={<Typography className="typography-generic mt-5neg">{localizer.Until}</Typography>}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          disableUnderline: true,
                          classes: {
                            input: "typography-generic color-gray mr-10 ml-10 mt-12neg"
                          },
                          inputProps: {
                            max: "9999-12-31"
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                </MuiPickersUtilsProvider>
                {isDateRangeBlocked &&
                  <div style={{ marginTop: 6 }}>
                    <span className="typography-generic" style={{ color: "red" }}>
                      {localizer.OutboxDateRangeMaxThreeMonths || "Lo sentimos no es posible realizar consultas de más de tres meses"}
                    </span>
                  </div>
                }
                {hasDirectShipmentCodeSearch &&
                  <div style={{ marginTop: 6 }}>
                    <span className="typography-generic" style={{ color: "#666" }}>
                      {localizer.OutboxShipmentCodeSearchIgnoresDateRange || "Al buscar por envío o tracking, el rango de fechas no se aplica"}
                    </span>
                  </div>
                }
              </Grid>
              {this.state.session && (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) &&
                <Grid item md={2}>
                  <Select className='typography-generic p-0' style={{ borderRadius: 0, height: 35, backgroundColor: 'white' }}
                    id="users"
                    fullWidth
                    onOpen={this.handleUsersOpen}
                    MenuProps={{
                      classes: { paper: "max-height-500" },
                      PaperProps: {
                        onScroll: this.handleUsersScroll
                      },
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                      },
                      getContentAnchorEl: null
                    }}
                    variant="outlined"
                    value={this.state.usersSelected}
                    multiple
                    onChange={this.handleChangeUser}
                    renderValue={(selected) => selected.map((x) => x.userEmail.toLowerCase()).join(', ')}
                  >
                    <MenuItem className="border-bottom-1-solid-primary  p-0" key="allUsers" value="allUsers" data-modal="allUsers">
                      <Checkbox
                        checked={this.state.isAllUsersSelected}
                        icon={<i className="fa-regular fa-square font-size-25 color-primary"></i>}
                        checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-primary"></i>}
                      />
                      <ListItemText
                        primary={<Typography className="typography-generic font-weight-bold">{this.state.isAllUsersSelected ? localizer.UnSelectAll : localizer.SelectAll}</Typography>}
                      />
                      <hr className="hr-custom" />
                    </MenuItem>

                    {this.state.users.map((user) => (
                      <MenuItem key={user.userId} value={user} data-modal={user.userId} className="pt-0 pb-0">
                        <Checkbox
                          color="primary"
                          //checked={this.state.showItemsSelected.includes(showItem) ? true : false}
                          checked={this.state.usersSelected ? this.state.usersSelected.find(s => s.userId === user.userId) ? true : false : false}
                          icon={<i className="fa-regular fa-square font-size-25 color-primary"></i>}
                          checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-primary"></i>}
                        />
                        <ListItemText primary={<Typography className="typography-generic">{user.userEmail.toLowerCase()}</Typography>} />
                      </MenuItem>
                    ))}
                  </Select>

                </Grid>
              }
              <Grid item md={2}>
                <TextFieldStyled id="shipmentCode" onChange={this.onInputChange} label={<Typography className="typography-generic">{localizer.Shipment}</Typography>}
                  name="shipmentCode" variant="outlined" value={this.state.filters.shipmentCode ? this.state.filters.shipmentCode : ""}
                  fullWidth
                  InputProps={{
                    classes: {
                      input: "typography-generic width-120 textinline pt-0 pb-0"
                    }
                  }}
                />
              </Grid>
            
              <Grid item md={2}>
                <Select className='typography-generic p-0' style={{ borderRadius: 0, height: 35, backgroundColor: 'white' }}
                  id="products"
                  fullWidth
                  MenuProps={{
                    classes: { paper: "max-height-500" },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                    getContentAnchorEl: null
                  }}
                  variant="outlined"
                  value={this.state.productSelected}
                  multiple
                  onChange={this.handleChangeProduct}
                  renderValue={(selected) => selected.map((x) => x.description).join(', ')}
                >
                  <MenuItem className="border-bottom-1-solid-primary p-0" key="allProducts" value="allProducts" data-modal="allProducts">
                    <Checkbox
                      checked={this.state.isAllProductsSelected}
                      icon={<i className="fa-regular fa-square font-size-25 color-primary"></i>}
                      checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-primary"></i>}
                    />
                    <ListItemText
                      primary={<Typography className="typography-generic font-weight-bold">{this.state.isAllProductsSelected ? localizer.UnSelectAll : localizer.SelectAll}</Typography>}
                    />
                    
                    <hr className="hr-custom" />
                  </MenuItem>
                  {this.state.products.map((product) => (
                    <MenuItem key={product.productCode} value={product} data-modal={product.productCode} className="pt-0 pb-0">
                      <Checkbox
                        color="primary"
                        //checked={this.state.showItemsSelected.includes(showItem) ? true : false}
                        checked={this.state.productSelected ? this.state.productSelected.find(p => p.productCode === product.productCode) ? true : false : false}
                        icon={<i className="fa-regular fa-square font-size-25 color-primary"></i>}
                        checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-primary"></i>}
                      />
                      <ListItemText primary={<Typography className="typography-generic">{product.description}</Typography>} />
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
              <Grid item md={2}>
                <TextFieldStyled id="reference" onChange={this.onInputChange} label={<Typography className="typography-generic">{localizer.Reference}</Typography>}
                  name="reference" variant="outlined" value={this.state.filters.reference ? this.state.filters.reference : ""}
                  fullWidth
                  InputProps={{
                    classes: {
                      input: "typography-generic"
                    }
                  }}
                />
              </Grid>
              <Grid item md={2}>
                <Select className='typography-generic p-0' style={{ borderRadius: 0, height: 35, backgroundColor: 'white' }}
                  id="status"
                  fullWidth
                  MenuProps={{
                    classes: { paper: "max-height-500" },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                    getContentAnchorEl: null
                  }}
                  variant="outlined"
                  value={this.state.stateCodeSelected}
                  multiple
                  onChange={this.handleChangeStatus}
                  //renderValue={(selected) => selected.map((x) => (StateCodes.CODES.find((item) => item.stateCode === x.stateCode).name)).join(', ')}
     
                  
                  renderValue={(selected) => selected.map((x) => {
                    //const item = StateCodes.FILTER_CODES.find((filterItem) => filterItem.stateCode.includes(x));
                    const item = StateCodes.FILTER_CODES.find(s => s.stateCode.join(',') === x.stateCode.join(','));

                    return item ? item.name : 'fffff';
                  }).join(', ')}
                >
                  <MenuItem className="border-bottom-1-solid-primary  p-0 height-40" key="allStates" value="allStates" data-modal="allStates">
                    <Checkbox
                      checked={this.state.isAllStatesSelected}
                      icon={<i className="fa-regular fa-square font-size-25 color-primary"></i>}
                      checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-primary"></i>}
                    />
                    <ListItemText
                      primary={<Typography className="typography-generic font-weight-bold">{this.state.isAllStatesSelected ? localizer.UnSelectAll : localizer.SelectAll}</Typography>}
                    />
                    <hr className="hr-custom" />
                  </MenuItem>

                  {this.getSortedFilterStates().map((status) => (
                    <MenuItem key={status.name} value={status.stateCode} data-modal={status.stateCode} className="pt-0 pb-0">
                      <Checkbox
                        color="primary"
                        checked={status.stateCode.every(code => this.state.stateCodeSelected.some(s => s.stateCode.includes(code)))}
                        icon={<i className="fa-regular fa-square font-size-25 color-primary"></i>}
                        checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-primary"></i>}
                      />
                      <ListItemText primary={<Typography className="typography-generic">{status.name}</Typography>} />
                    </MenuItem>
                  ))}
                
                </Select>
              </Grid>
            </Grid>
            
            
            {/* collapse more filter */}
            <Collapse in={this.state.open} timeout="auto" unmountOnExit style={{ width: "100%" }}>
              <Grid container item md={12} direction="row" justify="center">
                <Grid item md={4} className="p-8">
                  <TextFieldStyled id="who" onChange={this.onInputChange} label={<Typography className="typography-generic">{localizer.InboxDestination}</Typography>}
                    name="who" variant="outlined" value={this.state.filters.who ? this.state.filters.who : ""}
                    fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic textinline pt-0 pb-0"
                      }
                    }}
                  />
                </Grid>
                <Grid item md={4} className="p-8">
                  <TextFieldStyled id="streetName" onChange={this.onInputChange} label={<Typography className="typography-generic">{localizer.StreetName}</Typography>}
                    name="streetName" variant="outlined" value={this.state.filters.streetName ? this.state.filters.streetName : ""}
                    fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic textinline pt-0 pb-0"
                      }
                    }}
                  />
                </Grid>
                <Grid item md={2} className="p-8">
                  <TextFieldStyled id="postalCode" onChange={this.onInputChange} label={<Typography className="typography-generic">{localizer.PostalCode}</Typography>}
                    name="postalCode" variant="outlined" value={this.state.filters.postalCode ? this.state.filters.postalCode : ""}
                    fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic textinline pt-0 pb-0"
                      }
                    }}
                  />
                </Grid>
                <Grid item md={2} className="p-8">
                  <TextFieldStyled id="locality" onChange={this.onInputChange} label={<Typography className="typography-generic">{localizer.Locality}</Typography>}
                    name="locality" variant="outlined" value={this.state.filters.locality ? this.state.filters.locality : ""}
                    fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic textinline pt-0 pb-0"
                      }
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container item md={12} direction="row" justify="flex-start">
                <Grid item md={4} className="p-8">
                  <AutocompleteStyled
                    options={this.state.batches}
                    value={this.state.batchSelected}
                    loading={this.state.batchesLoading}
                    loadingText={<Typography className="typography-generic">{localizer.WaitingData}</Typography>}
                    onOpen={this.handleBatchesOpen}
                    onChange={this.handleChangeBatch}
                    onInputChange={this.handleBatchInputChange}
                    getOptionLabel={(option) => this.formatBatchText(option)}
                    getOptionSelected={(option, value) => option.batchId === value.batchId}
                    noOptionsText={<Typography className="typography-generic">{localizer.OptionNotFound}</Typography>}
                    ListboxProps={{
                      onScroll: this.handleBatchScroll,
                      style: {
                        maxHeight: BATCH_LISTBOX_MAX_HEIGHT,
                        overflowY: this.state.hasMoreBatches || this.state.batchesLoading ? "scroll" : "auto",
                        scrollbarGutter: "stable"
                      }
                    }}
                    renderOption={(option) => (
                      <MenuItem key={option.batchId} value={option} className="pt-0 pb-0">
                        <ListItemText primary={<Typography className="typography-generic">{this.formatBatchText(option)}</Typography>} />
                      </MenuItem>
                    )}
                    renderInput={(params) => (
                      <TextFieldStyled
                        {...params}
                        variant="outlined"
                        label={<Typography className="typography-generic">{localizer.Batch || "Batch"}</Typography>}
                        placeholder={localizer.BatchSearchPlaceholder || localizer.Search}
                        InputProps={{
                          ...params.InputProps,
                          classes: {
                            input: "typography-generic"
                          }
                        }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Collapse>

            <Grid item md={12} className="text-align-right p-10">
              <label >{this.state.open ? localizer.ExpandLessFilter : localizer.ExpandMoreFilter}</label>
              <IconButton aria-label="expand row" size="small" onClick={this.setOpen}>
                {this.state.open ? <i className="fa-solid fa-angle-up font-size-20"></i> : <i className="fa-solid fa-angle-down font-size-20"></i>}
              </IconButton>
            </Grid>
          </GridHeaderFilter>
          
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid container justify="flex-start" alignitems="flex-start">

              <Grid item md={3}>
                {localizer.TotalShipments}:&nbsp;<b>{CurrencyCustom.numberFormatter(this.state.totalShipments)}</b> &nbsp;&nbsp;{localizer.TotalDisplayed}:&nbsp;<b>{CurrencyCustom.numberFormatter(this.state.shipments.length)}</b>&nbsp;&nbsp;{localizer.TotalSelected}:&nbsp;<b>{CurrencyCustom.numberFormatter(this.state.shipmentsCodesSelected.length)}</b>
              </Grid>
              <Grid item md={9} className="text-align-right">
                <FormControlLabel className="mr-10" style={{ margin: 0, verticalAlign: "bottom" }}
                  control={<Checkbox className="checkbox-custom" name="cancelRequested" checked={this.state.filters.cancelRequested} onChange={this.onInputChange} />}
                  label={<Typography className="typography-generic">{localizer.ShowCancelRequested}</Typography>}
                />
                <Button className="button-generic downloadTable" variant="contained" disabled={disabledbuttondownload} onClick={this.downloadShipmentsReturns} startIcon={<i className="fa-solid fa-file-zipper"></i>}>
                  {localizer.OutboxDownloadReturns}
                </Button>
                <Button className="button-generic downloadTable" variant="contained" onClick={this.downloadExcel} startIcon={<i className="fa-solid fa-file-excel"></i>}>
                  {localizer.OutboxDownloadExcel}
                </Button>
              </Grid>
              
            </Grid>
            <TableContainer component={Paper}>
              <TableStyled aria-label="collapsible table">
                <TableHead>
                  <TableRowHeaderStyled>
                    <TableCellStyled align="center">
                      <Checkbox
                        checked={this.state.checkedAll}
                        onChange={this.onChangeSelectAll}
                        name="checkedAll"
                        color="primary"
                        icon={<i className="fa-regular fa-square font-size-25 color-primary"></i>}
                        checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-primary"></i>}
                      />
                    </TableCellStyled>
                    <TableCellStyled />
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Shipment}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Type}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.User}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Reference}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Sent}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Addressee}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Status}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Tracking}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Actions}</Typography></TableCellStyled>
                  </TableRowHeaderStyled>
                </TableHead>
                <TableBody>
                  {shipmentRows.length > 0 ? shipmentRows :
                    <TableRowStyled><TableCellStyled colSpan={13} className="typography-generic tablerow-content font-weight-bold" align="center">{this.state.isLoading ? localizer.WaitingData : localizer.NotFound}</TableCellStyled></TableRowStyled>
                  }
                </TableBody>
              </TableStyled>
            </TableContainer>
          </Grid>
          {/* ================================================================================= */}
          {/* PAGINATION UI (rows per page selector + page navigator) */}
          {/* ================================================================================= */}
          <Grid container direction="row" justify="flex-end" alignItems="center" style={{ paddingTop: 25 }}>
            <Grid item>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 12, flexWrap: 'nowrap' }}>
                <span className="typography-generic">
                  {localizer.RowsPerPage || "Envíos por página"}:
                </span>
                <Select
                  value={this.state.pageSize}
                  onChange={this.handleChangeRowsPerPage}
                  variant="outlined"
                  className="typography-generic"
                  style={{ height: 35, backgroundColor: 'white', minWidth: 88 }}
                  renderValue={(selected) => <span className="typography-generic">{selected}</span>}
                >
                  {SHIPMENT_PAGE_SIZE_OPTIONS.map((option) => (
                    <MenuItem key={option} value={option}>
                      <Typography className="typography-generic">{option}</Typography>
                    </MenuItem>
                  ))}
                </Select>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  // UI page is 1-based; convert back to internal 0-based page index.
                  onChange={(event, page) => this.handleChangePage(page - 1)}
                  shape="rounded"
                  color="primary"
                  showFirstButton
                  showLastButton
                  size="small"
                  renderItem={(item) => (
                    <PaginationItem
                      {...item}
                      className="typography-generic"
                      style={item.selected ? { backgroundColor: 'var(--custom-primary-color)', color: '#ffffff' } : null}
                    />
                  )}
                />
              </div>
            </Grid>
          </Grid>
          {/* ============================= END PAGINATION UI ============================= */}
        </Container>

        {/* Upload draft error. */}
        <SnackbarCustom message={this.state.shipmentsError} severity="error" handleonClose={this.handleonClose} />
    
        {/* Upload draft error. */}
        <SnackbarCustom message={this.state.shipmentRemoveError} severity="error" handleonClose={this.handleonClose} />

        {/* Upload draft error. */}
        <SnackbarCustom message={this.state.productError} severity="error" handleonClose={this.handleonClose} />

        
        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 100 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/outbox/OutboxLayout.js